import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
  DuoPreferencesResponse,
  DuoPreferencesUpdateRequest,
  UpdateData,
} from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';

import { getDuoPreferencesKey } from '../useGetDuoPreferences/getDuoPreferences.options';

const updateDuoPreferencesUrl: UpdateData['url'] = 'duo-preferences';

const updateDuoPreferences = async (data: DuoPreferencesUpdateRequest) => {
  return PrivateApi.patch(updateDuoPreferencesUrl, {
    json: data,
  }).json<DuoPreferencesResponse>();
};

export function useUpdateDuoPreferences() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateDuoPreferences,
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: getDuoPreferencesKey(),
      }),
  });
}
